import React from 'react';
import s from './Features.module.css';
import Ribbon from '../../Ribbon/Ribbon';

function Features({
  featuresFirstText,
  featuresSecondText,
  featuresThirdText,
  featuresFirstBackground,
  featuresSecondBackground,
  featuresThirdBackground,
}) {
  return (
    <section className={s.section} id="features">
      <ul className={s.list}>
        <li
          className={s.item}
          style={{ backgroundImage: `url(${featuresFirstBackground})` }}
        >
          <div className={s.div}>
            <p className={s.text}>{featuresFirstText}</p>
          </div>
        </li>
        <li
          className={s.item}
          style={{ backgroundImage: `url(${featuresSecondBackground})` }}
        >
          <div className={s.divSecond}>
            <p className={s.textSecond}>{featuresSecondText}</p>
          </div>
        </li>
        <li
          className={s.item}
          style={{ backgroundImage: `url(${featuresThirdBackground})` }}
        >
          <div className={s.div}>
            <p className={s.textThird}>{featuresThirdText}</p>
          </div>
        </li>
      </ul>
      <div className={s.ribbon}>
        <Ribbon />
      </div>
    </section>
  );
}

export default Features;
